import { useRef as Ls, useLayoutEffect as zs, useEffect as oe, useState as Fe, useCallback as Bs, useMemo as Us } from "react";
function Ws(t) {
  const e = Ls(null);
  return e.current === null && (e.current = t()), e.current;
}
const Ks = typeof window < "u", qs = Ks ? zs : oe;
function Gs(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Ys(t, e) {
  const s = t.indexOf(e);
  s > -1 && t.splice(s, 1);
}
const X = (t, e, s) => s > e ? e : s < t ? t : s;
function Xe(t, e) {
  return e ? `${t}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : t;
}
let Ae = () => {
}, Q = () => {
};
var es;
typeof process < "u" && ((es = process.env) == null ? void 0 : es.NODE_ENV) !== "production" && (Ae = (t, e, s) => {
  !t && typeof console < "u" && console.warn(Xe(e, s));
}, Q = (t, e, s) => {
  if (!t)
    throw new Error(Xe(e, s));
});
const ee = {};
// @__NO_SIDE_EFFECTS__
function ts(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const ge = /* @__NO_SIDE_EFFECTS__ */ (t) => t, Hs = (t, e) => (s) => e(t(s)), yt = (...t) => t.reduce(Hs), ss = /* @__NO_SIDE_EFFECTS__ */ (t, e, s) => {
  const n = e - t;
  return n === 0 ? 1 : (s - t) / n;
};
class Js {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return Gs(this.subscriptions, e), () => Ys(this.subscriptions, e);
  }
  notify(e, s, n) {
    const r = this.subscriptions.length;
    if (r)
      if (r === 1)
        this.subscriptions[0](e, s, n);
      else
        for (let i = 0; i < r; i++) {
          const a = this.subscriptions[i];
          a && a(e, s, n);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const B = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, z = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3;
function ns(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const Ct = /* @__PURE__ */ new Set();
function Xs(t, e, s) {
  t || Ct.has(e) || (console.warn(Xe(e, s)), Ct.add(e));
}
const rs = (t, e, s) => (((1 - 3 * s + 3 * e) * t + (3 * s - 6 * e)) * t + 3 * e) * t, Qs = 1e-7, en = 12;
function tn(t, e, s, n, r) {
  let i, a, o = 0;
  do
    a = e + (s - e) / 2, i = rs(a, n, r) - t, i > 0 ? s = a : e = a;
  while (Math.abs(i) > Qs && ++o < en);
  return a;
}
function Se(t, e, s, n) {
  if (t === e && s === n)
    return ge;
  const r = (i) => tn(i, 0, 1, t, s);
  return (i) => i === 0 || i === 1 ? i : rs(r(i), e, n);
}
const is = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, as = (t) => (e) => 1 - t(1 - e), os = /* @__PURE__ */ Se(0.33, 1.53, 0.69, 0.99), gt = /* @__PURE__ */ as(os), cs = /* @__PURE__ */ is(gt), ls = (t) => t >= 1 ? 1 : (t *= 2) < 1 ? 0.5 * gt(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), vt = (t) => 1 - Math.sin(Math.acos(t)), sn = as(vt), us = is(vt), nn = /* @__PURE__ */ Se(0.42, 0, 1, 1), rn = /* @__PURE__ */ Se(0, 0, 0.58, 1), ds = /* @__PURE__ */ Se(0.42, 0, 0.58, 1), an = (t) => Array.isArray(t) && typeof t[0] != "number", fs = (t) => Array.isArray(t) && typeof t[0] == "number", Ot = {
  linear: ge,
  easeIn: nn,
  easeInOut: ds,
  easeOut: rn,
  circIn: vt,
  circInOut: us,
  circOut: sn,
  backIn: gt,
  backInOut: cs,
  backOut: os,
  anticipate: ls
}, on = (t) => typeof t == "string", Mt = (t) => {
  if (fs(t)) {
    Q(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [e, s, n, r] = t;
    return Se(e, s, n, r);
  } else if (on(t))
    return Q(Ot[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), Ot[t];
  return t;
}, Oe = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Rt = {
  value: null,
  addProjectionMetrics: null
};
function cn(t, e) {
  let s = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, c = 0;
  function l(f) {
    a.has(f) && (u.schedule(f), t()), c++, f(o);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (f, y = !1, A = !1) => {
      const _ = A && r ? s : n;
      return y && a.add(f), _.add(f), f;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (f) => {
      n.delete(f), a.delete(f);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (f) => {
      if (o = f, r) {
        i = !0;
        return;
      }
      r = !0;
      const y = s;
      s = n, n = y, s.forEach(l), e && Rt.value && Rt.value.frameloop[e].push(c), c = 0, s.clear(), r = !1, i && (i = !1, u.process(f));
    }
  };
  return u;
}
const ln = 40;
function un(t, e) {
  let s = !1, n = !0;
  const r = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => s = !0, a = Oe.reduce((N, R) => (N[R] = cn(i, e ? R : void 0), N), {}), { setup: o, read: c, resolveKeyframes: l, preUpdate: u, update: f, preRender: y, render: A, postRender: M } = a, _ = () => {
    const N = ee.useManualTiming, R = N ? r.timestamp : performance.now();
    s = !1, N || (r.delta = n ? 1e3 / 60 : Math.max(Math.min(R - r.timestamp, ln), 1)), r.timestamp = R, r.isProcessing = !0, o.process(r), c.process(r), l.process(r), u.process(r), f.process(r), y.process(r), A.process(r), M.process(r), r.isProcessing = !1, s && e && (n = !1, t(_));
  }, x = () => {
    s = !0, n = !0, r.isProcessing || t(_);
  };
  return { schedule: Oe.reduce((N, R) => {
    const O = a[R];
    return N[R] = (Z, L = !1, C = !1) => (s || x(), O.schedule(Z, L, C)), N;
  }, {}), cancel: (N) => {
    for (let R = 0; R < Oe.length; R++)
      a[Oe[R]].cancel(N);
  }, state: r, steps: a };
}
const { schedule: H, cancel: dn, state: Re, steps: qi } = /* @__PURE__ */ un(typeof requestAnimationFrame < "u" ? requestAnimationFrame : ge, !0);
let Me;
function fn() {
  Me = void 0;
}
const j = {
  now: () => (Me === void 0 && j.set(Re.isProcessing || ee.useManualTiming ? Re.timestamp : performance.now()), Me),
  set: (t) => {
    Me = t, queueMicrotask(fn);
  }
}, hn = (t) => (e) => typeof e == "string" && e.startsWith(t), mn = /* @__PURE__ */ hn("var(--"), pn = (t) => mn(t) ? yn.test(t.split("/*")[0].trim()) : !1, yn = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, hs = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, ms = {
  ...hs,
  transform: (t) => X(0, 1, t)
}, be = (t) => Math.round(t * 1e5) / 1e5, ps = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function gn(t) {
  return t == null;
}
const vn = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, _t = (t, e) => (s) => !!(typeof s == "string" && vn.test(s) && s.startsWith(t) || e && !gn(s) && Object.prototype.hasOwnProperty.call(s, e)), ys = (t, e, s) => (n) => {
  if (typeof n != "string")
    return n;
  const [r, i, a, o] = n.match(ps);
  return {
    [t]: parseFloat(r),
    [e]: parseFloat(i),
    [s]: parseFloat(a),
    alpha: o !== void 0 ? parseFloat(o) : 1
  };
}, _n = (t) => X(0, 255, t), Be = {
  ...hs,
  transform: (t) => Math.round(_n(t))
}, re = {
  test: /* @__PURE__ */ _t("rgb", "red"),
  parse: /* @__PURE__ */ ys("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: s, alpha: n = 1 }) => "rgba(" + Be.transform(t) + ", " + Be.transform(e) + ", " + Be.transform(s) + ", " + be(ms.transform(n)) + ")"
};
function bn(t) {
  let e = "", s = "", n = "", r = "";
  return t.length > 5 ? (e = t.substring(1, 3), s = t.substring(3, 5), n = t.substring(5, 7), r = t.substring(7, 9)) : (e = t.substring(1, 2), s = t.substring(2, 3), n = t.substring(3, 4), r = t.substring(4, 5), e += e, s += s, n += n, r += r), {
    red: parseInt(e, 16),
    green: parseInt(s, 16),
    blue: parseInt(n, 16),
    alpha: r ? parseInt(r, 16) / 255 : 1
  };
}
const Qe = {
  test: /* @__PURE__ */ _t("#"),
  parse: bn,
  transform: re.transform
}, xn = /* @__NO_SIDE_EFFECTS__ */ (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), Nt = /* @__PURE__ */ xn("%"), de = {
  test: /* @__PURE__ */ _t("hsl", "hue"),
  parse: /* @__PURE__ */ ys("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: s, alpha: n = 1 }) => "hsla(" + Math.round(t) + ", " + Nt.transform(be(e)) + ", " + Nt.transform(be(s)) + ", " + be(ms.transform(n)) + ")"
}, W = {
  test: (t) => re.test(t) || Qe.test(t) || de.test(t),
  parse: (t) => re.test(t) ? re.parse(t) : de.test(t) ? de.parse(t) : Qe.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? re.transform(t) : de.transform(t),
  getAnimatableNone: (t) => {
    const e = W.parse(t);
    return e.alpha = 0, W.transform(e);
  }
}, kn = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Tn(t) {
  var e, s;
  return isNaN(t) && typeof t == "string" && (((e = t.match(ps)) == null ? void 0 : e.length) || 0) + (((s = t.match(kn)) == null ? void 0 : s.length) || 0) > 0;
}
const gs = "number", vs = "color", wn = "var", An = "var(", Et = "${}", Sn = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function xe(t) {
  const e = t.toString(), s = [], n = {
    color: [],
    number: [],
    var: []
  }, r = [];
  let i = 0;
  const o = e.replace(Sn, (c) => (W.test(c) ? (n.color.push(i), r.push(vs), s.push(W.parse(c))) : c.startsWith(An) ? (n.var.push(i), r.push(wn), s.push(c)) : (n.number.push(i), r.push(gs), s.push(parseFloat(c))), ++i, Et)).split(Et);
  return { values: s, split: o, indexes: n, types: r };
}
function Cn(t) {
  return xe(t).values;
}
function _s({ split: t, types: e }) {
  const s = t.length;
  return (n) => {
    let r = "";
    for (let i = 0; i < s; i++)
      if (r += t[i], n[i] !== void 0) {
        const a = e[i];
        a === gs ? r += be(n[i]) : a === vs ? r += W.transform(n[i]) : r += n[i];
      }
    return r;
  };
}
function On(t) {
  return _s(xe(t));
}
const Mn = (t) => typeof t == "number" ? 0 : W.test(t) ? W.getAnimatableNone(t) : t, Rn = (t, e) => typeof t == "number" ? e != null && e.trim().endsWith("/") ? t : 0 : Mn(t);
function Nn(t) {
  const e = xe(t);
  return _s(e)(e.values.map((n, r) => Rn(n, e.split[r])));
}
const bs = {
  test: Tn,
  parse: Cn,
  createTransformer: On,
  getAnimatableNone: Nn
};
function Ue(t, e, s) {
  return s < 0 && (s += 1), s > 1 && (s -= 1), s < 1 / 6 ? t + (e - t) * 6 * s : s < 1 / 2 ? e : s < 2 / 3 ? t + (e - t) * (2 / 3 - s) * 6 : t;
}
function En({ hue: t, saturation: e, lightness: s, alpha: n }) {
  t /= 360, e /= 100, s /= 100;
  let r = 0, i = 0, a = 0;
  if (!e)
    r = i = a = s;
  else {
    const o = s < 0.5 ? s * (1 + e) : s + e - s * e, c = 2 * s - o;
    r = Ue(c, o, t + 1 / 3), i = Ue(c, o, t), a = Ue(c, o, t - 1 / 3);
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: n
  };
}
function Ne(t, e) {
  return (s) => s > 0 ? e : t;
}
const Le = (t, e, s) => t + (e - t) * s, We = (t, e, s) => {
  const n = t * t, r = s * (e * e - n) + n;
  return r < 0 ? 0 : Math.sqrt(r);
}, In = [Qe, re, de], Vn = (t) => In.find((e) => e.test(t));
function It(t) {
  const e = Vn(t);
  if (Ae(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e)
    return !1;
  let s = e.parse(t);
  return e === de && (s = En(s)), s;
}
const Vt = (t, e) => {
  const s = It(t), n = It(e);
  if (!s || !n)
    return Ne(t, e);
  const r = { ...s };
  return (i) => (r.red = We(s.red, n.red, i), r.green = We(s.green, n.green, i), r.blue = We(s.blue, n.blue, i), r.alpha = Le(s.alpha, n.alpha, i), re.transform(r));
}, et = /* @__PURE__ */ new Set(["none", "hidden"]);
function Dn(t, e) {
  return et.has(t) ? (s) => s <= 0 ? t : e : (s) => s >= 1 ? e : t;
}
function Zn(t, e) {
  return (s) => Le(t, e, s);
}
function bt(t) {
  return typeof t == "number" ? Zn : typeof t == "string" ? pn(t) ? Ne : W.test(t) ? Vt : jn : Array.isArray(t) ? xs : typeof t == "object" ? W.test(t) ? Vt : Pn : Ne;
}
function xs(t, e) {
  const s = [...t], n = s.length, r = t.map((i, a) => bt(i)(i, e[a]));
  return (i) => {
    for (let a = 0; a < n; a++)
      s[a] = r[a](i);
    return s;
  };
}
function Pn(t, e) {
  const s = { ...t, ...e }, n = {};
  for (const r in s)
    t[r] !== void 0 && e[r] !== void 0 && (n[r] = bt(t[r])(t[r], e[r]));
  return (r) => {
    for (const i in n)
      s[i] = n[i](r);
    return s;
  };
}
function $n(t, e) {
  const s = [], n = { color: 0, var: 0, number: 0 };
  for (let r = 0; r < e.values.length; r++) {
    const i = e.types[r], a = t.indexes[i][n[i]], o = t.values[a] ?? 0;
    s[r] = o, n[i]++;
  }
  return s;
}
const jn = (t, e) => {
  const s = bs.createTransformer(e), n = xe(t), r = xe(e);
  return n.indexes.var.length === r.indexes.var.length && n.indexes.color.length === r.indexes.color.length && n.indexes.number.length >= r.indexes.number.length ? et.has(t) && !r.values.length || et.has(e) && !n.values.length ? Dn(t, e) : yt(xs($n(n, r), r.values), s) : (Ae(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Ne(t, e));
};
function ks(t, e, s) {
  return typeof t == "number" && typeof e == "number" && typeof s == "number" ? Le(t, e, s) : bt(t)(t, e);
}
const Fn = (t) => {
  const e = ({ timestamp: s }) => t(s);
  return {
    start: (s = !0) => H.update(e, s),
    stop: () => dn(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Re.isProcessing ? Re.timestamp : j.now()
  };
}, Ts = (t, e, s = 10) => {
  let n = "";
  const r = Math.max(Math.round(e / s), 2);
  for (let i = 0; i < r; i++)
    n += Math.round(t(i / (r - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
}, Ee = 2e4;
function xt(t) {
  let e = 0;
  const s = 50;
  let n = t.next(e);
  for (; !n.done && e < Ee; )
    e += s, n = t.next(e);
  return e >= Ee ? 1 / 0 : e;
}
function Ln(t, e = 100, s) {
  const n = s({ ...t, keyframes: [0, e] }), r = Math.min(xt(n), Ee);
  return {
    type: "keyframes",
    ease: (i) => n.next(r * i).value / e,
    duration: /* @__PURE__ */ z(r)
  };
}
const E = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function tt(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const zn = 12;
function Bn(t, e, s) {
  let n = s;
  for (let r = 1; r < zn; r++)
    n = n - t(n) / e(n);
  return n;
}
const Ke = 1e-3;
function Un({ duration: t = E.duration, bounce: e = E.bounce, velocity: s = E.velocity, mass: n = E.mass }) {
  let r, i;
  Ae(t <= /* @__PURE__ */ B(E.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let a = 1 - e;
  a = X(E.minDamping, E.maxDamping, a), t = X(E.minDuration, E.maxDuration, /* @__PURE__ */ z(t)), a < 1 ? (r = (l) => {
    const u = l * a, f = u * t, y = u - s, A = tt(l, a), M = Math.exp(-f);
    return Ke - y / A * M;
  }, i = (l) => {
    const f = l * a * t, y = f * s + s, A = Math.pow(a, 2) * Math.pow(l, 2) * t, M = Math.exp(-f), _ = tt(Math.pow(l, 2), a);
    return (-r(l) + Ke > 0 ? -1 : 1) * ((y - A) * M) / _;
  }) : (r = (l) => {
    const u = Math.exp(-l * t), f = (l - s) * t + 1;
    return -Ke + u * f;
  }, i = (l) => {
    const u = Math.exp(-l * t), f = (s - l) * (t * t);
    return u * f;
  });
  const o = 5 / t, c = Bn(r, i, o);
  if (t = /* @__PURE__ */ B(t), isNaN(c))
    return {
      stiffness: E.stiffness,
      damping: E.damping,
      duration: t
    };
  {
    const l = Math.pow(c, 2) * n;
    return {
      stiffness: l,
      damping: a * 2 * Math.sqrt(n * l),
      duration: t
    };
  }
}
const Wn = ["duration", "bounce"], Kn = ["stiffness", "damping", "mass"];
function Dt(t, e) {
  return e.some((s) => t[s] !== void 0);
}
function qn(t) {
  let e = {
    velocity: E.velocity,
    stiffness: E.stiffness,
    damping: E.damping,
    mass: E.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!Dt(t, Kn) && Dt(t, Wn))
    if (e.velocity = 0, t.visualDuration) {
      const s = t.visualDuration, n = 2 * Math.PI / (s * 1.2), r = n * n, i = 2 * X(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(r);
      e = {
        ...e,
        mass: E.mass,
        stiffness: r,
        damping: i
      };
    } else {
      const s = Un({ ...t, velocity: 0 });
      e = {
        ...e,
        ...s,
        mass: E.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function Ie(t = E.visualDuration, e = E.bounce) {
  const s = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: n, restDelta: r } = s;
  const i = s.keyframes[0], a = s.keyframes[s.keyframes.length - 1], o = { done: !1, value: i }, { stiffness: c, damping: l, mass: u, duration: f, velocity: y, isResolvedFromDuration: A } = qn({
    ...s,
    velocity: -/* @__PURE__ */ z(s.velocity || 0)
  }), M = y || 0, _ = l / (2 * Math.sqrt(c * u)), x = a - i, T = /* @__PURE__ */ z(Math.sqrt(c / u)), D = Math.abs(x) < 5;
  n || (n = D ? E.restSpeed.granular : E.restSpeed.default), r || (r = D ? E.restDelta.granular : E.restDelta.default);
  let N, R, O, Z, L, C;
  if (_ < 1)
    O = tt(T, _), Z = (M + _ * T * x) / O, N = (b) => {
      const V = Math.exp(-_ * T * b);
      return a - V * (Z * Math.sin(O * b) + x * Math.cos(O * b));
    }, L = _ * T * Z + x * O, C = _ * T * x - Z * O, R = (b) => Math.exp(-_ * T * b) * (L * Math.sin(O * b) + C * Math.cos(O * b));
  else if (_ === 1) {
    N = (V) => a - Math.exp(-T * V) * (x + (M + T * x) * V);
    const b = M + T * x;
    R = (V) => Math.exp(-T * V) * (T * b * V - M);
  } else {
    const b = T * Math.sqrt(_ * _ - 1);
    N = (G) => {
      const le = Math.exp(-_ * T * G), ne = Math.min(b * G, 300);
      return a - le * ((M + _ * T * x) * Math.sinh(ne) + b * x * Math.cosh(ne)) / b;
    };
    const V = (M + _ * T * x) / b, q = _ * T * V - x * b, Ce = _ * T * x - V * b;
    R = (G) => {
      const le = Math.exp(-_ * T * G), ne = Math.min(b * G, 300);
      return le * (q * Math.sinh(ne) + Ce * Math.cosh(ne));
    };
  }
  const P = {
    calculatedDuration: A && f || null,
    velocity: (b) => /* @__PURE__ */ B(R(b)),
    next: (b) => {
      if (!A && _ < 1) {
        const q = Math.exp(-_ * T * b), Ce = Math.sin(O * b), G = Math.cos(O * b), le = a - q * (Z * Ce + x * G), ne = /* @__PURE__ */ B(q * (L * Ce + C * G));
        return o.done = Math.abs(ne) <= n && Math.abs(a - le) <= r, o.value = o.done ? a : le, o;
      }
      const V = N(b);
      if (A)
        o.done = b >= f;
      else {
        const q = /* @__PURE__ */ B(R(b));
        o.done = Math.abs(q) <= n && Math.abs(a - V) <= r;
      }
      return o.value = o.done ? a : V, o;
    },
    toString: () => {
      const b = Math.min(xt(P), Ee), V = Ts((q) => P.next(b * q).value, b, 30);
      return b + "ms " + V;
    },
    toTransition: () => {
    }
  };
  return P;
}
Ie.applyToOptions = (t) => {
  const e = Ln(t, 100, Ie);
  return t.ease = e.ease, t.duration = /* @__PURE__ */ B(e.duration), t.type = "keyframes", t;
};
const Gn = 5;
function ws(t, e, s) {
  const n = Math.max(e - Gn, 0);
  return ns(s - t(n), e - n);
}
function st({ keyframes: t, velocity: e = 0, power: s = 0.8, timeConstant: n = 325, bounceDamping: r = 10, bounceStiffness: i = 500, modifyTarget: a, min: o, max: c, restDelta: l = 0.5, restSpeed: u }) {
  const f = t[0], y = {
    done: !1,
    value: f
  }, A = (C) => o !== void 0 && C < o || c !== void 0 && C > c, M = (C) => o === void 0 ? c : c === void 0 || Math.abs(o - C) < Math.abs(c - C) ? o : c;
  let _ = s * e;
  const x = f + _, T = a === void 0 ? x : a(x);
  T !== x && (_ = T - f);
  const D = (C) => -_ * Math.exp(-C / n), N = (C) => T + D(C), R = (C) => {
    const P = D(C), b = N(C);
    y.done = Math.abs(P) <= l, y.value = y.done ? T : b;
  };
  let O, Z;
  const L = (C) => {
    A(y.value) && (O = C, Z = Ie({
      keyframes: [y.value, M(y.value)],
      velocity: ws(N, C, y.value),
      // TODO: This should be passing * 1000
      damping: r,
      stiffness: i,
      restDelta: l,
      restSpeed: u
    }));
  };
  return L(0), {
    calculatedDuration: null,
    next: (C) => {
      let P = !1;
      return !Z && O === void 0 && (P = !0, R(C), L(C)), O !== void 0 && C >= O ? Z.next(C - O) : (!P && R(C), y);
    }
  };
}
function Yn(t, e, s) {
  const n = [], r = s || ee.mix || ks, i = t.length - 1;
  for (let a = 0; a < i; a++) {
    let o = r(t[a], t[a + 1]);
    if (e) {
      const c = Array.isArray(e) ? e[a] || ge : e;
      o = yt(c, o);
    }
    n.push(o);
  }
  return n;
}
function Hn(t, e, { clamp: s = !0, ease: n, mixer: r } = {}) {
  const i = t.length;
  if (Q(i === e.length, "Both input and output ranges must be the same length", "range-length"), i === 1)
    return () => e[0];
  if (i === 2 && e[0] === e[1])
    return () => e[1];
  const a = t[0] === t[1];
  t[0] > t[i - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const o = Yn(e, n, r), c = o.length, l = (u) => {
    if (a && u < t[0])
      return e[0];
    let f = 0;
    if (c > 1)
      for (; f < t.length - 2 && !(u < t[f + 1]); f++)
        ;
    const y = /* @__PURE__ */ ss(t[f], t[f + 1], u);
    return o[f](y);
  };
  return s ? (u) => l(X(t[0], t[i - 1], u)) : l;
}
function Jn(t, e) {
  const s = t[t.length - 1];
  for (let n = 1; n <= e; n++) {
    const r = /* @__PURE__ */ ss(0, e, n);
    t.push(Le(s, 1, r));
  }
}
function Xn(t) {
  const e = [0];
  return Jn(e, t.length - 1), e;
}
function Qn(t, e) {
  return t.map((s) => s * e);
}
function er(t, e) {
  return t.map(() => e || ds).splice(0, t.length - 1);
}
function fe({ duration: t = 300, keyframes: e, times: s, ease: n = "easeInOut" }) {
  const r = an(n) ? n.map(Mt) : Mt(n), i = {
    done: !1,
    value: e[0]
  }, a = Qn(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    s && s.length === e.length ? s : Xn(e),
    t
  ), o = Hn(a, e, {
    ease: Array.isArray(r) ? r : er(e, r)
  });
  return {
    calculatedDuration: t,
    next: (c) => (i.value = o(c), i.done = c >= t, i)
  };
}
const tr = (t) => t !== null;
function ze(t, { repeat: e, repeatType: s = "loop" }, n, r = 1) {
  const i = t.filter(tr), o = r < 0 || e && s !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return !o || n === void 0 ? i[o] : n;
}
const sr = {
  decay: st,
  inertia: st,
  tween: fe,
  keyframes: fe,
  spring: Ie
};
function As(t) {
  typeof t.type == "string" && (t.type = sr[t.type]);
}
class kt {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, s) {
    return this.finished.then(e, s);
  }
}
const nr = (t) => t / 100;
class Ve extends kt {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      var n, r;
      const { motionValue: s } = this.options;
      s && s.updatedAt !== j.now() && this.tick(j.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (r = (n = this.options).onStop) == null || r.call(n));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    As(e);
    const { type: s = fe, repeat: n = 0, repeatDelay: r = 0, repeatType: i, velocity: a = 0 } = e;
    let { keyframes: o } = e;
    const c = s || fe;
    process.env.NODE_ENV !== "production" && c !== fe && Q(o.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${o}`, "spring-two-frames"), c !== fe && typeof o[0] != "number" && (this.mixKeyframes = yt(nr, ks(o[0], o[1])), o = [0, 100]);
    const l = c({ ...e, keyframes: o });
    i === "mirror" && (this.mirroredGenerator = c({
      ...e,
      keyframes: [...o].reverse(),
      velocity: -a
    })), l.calculatedDuration === null && (l.calculatedDuration = xt(l));
    const { calculatedDuration: u } = l;
    this.calculatedDuration = u, this.resolvedDuration = u + r, this.totalDuration = this.resolvedDuration * (n + 1) - r, this.generator = l;
  }
  updateTime(e) {
    const s = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = s;
  }
  tick(e, s = !1) {
    const { generator: n, totalDuration: r, mixKeyframes: i, mirroredGenerator: a, resolvedDuration: o, calculatedDuration: c } = this;
    if (this.startTime === null)
      return n.next(0);
    const { delay: l = 0, keyframes: u, repeat: f, repeatType: y, repeatDelay: A, type: M, onUpdate: _, finalKeyframe: x } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - r / this.speed, this.startTime)), s ? this.currentTime = e : this.updateTime(e);
    const T = this.currentTime - l * (this.playbackSpeed >= 0 ? 1 : -1), D = this.playbackSpeed >= 0 ? T < 0 : T > r;
    this.currentTime = Math.max(T, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = r);
    let N = this.currentTime, R = n;
    if (f) {
      const C = Math.min(this.currentTime, r) / o;
      let P = Math.floor(C), b = C % 1;
      !b && C >= 1 && (b = 1), b === 1 && P--, P = Math.min(P, f + 1), !!(P % 2) && (y === "reverse" ? (b = 1 - b, A && (b -= A / o)) : y === "mirror" && (R = a)), N = X(0, 1, b) * o;
    }
    let O;
    D ? (this.delayState.value = u[0], O = this.delayState) : O = R.next(N), i && !D && (O.value = i(O.value));
    let { done: Z } = O;
    !D && c !== null && (Z = this.playbackSpeed >= 0 ? this.currentTime >= r : this.currentTime <= 0);
    const L = this.holdTime === null && (this.state === "finished" || this.state === "running" && Z);
    return L && M !== st && (O.value = ze(u, this.options, x, this.speed)), _ && _(O.value), L && this.finish(), O;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, s) {
    return this.finished.then(e, s);
  }
  get duration() {
    return /* @__PURE__ */ z(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ z(e);
  }
  get time() {
    return /* @__PURE__ */ z(this.currentTime);
  }
  set time(e) {
    e = /* @__PURE__ */ B(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = e, this.tick(e));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const e = this.currentTime;
    if (e <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(e);
    const s = this.generator.next(e).value;
    return ws((n) => this.generator.next(n).value, e, s);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const s = this.playbackSpeed !== e;
    s && this.driver && this.updateTime(j.now()), this.playbackSpeed = e, s && this.driver && (this.time = /* @__PURE__ */ z(this.currentTime));
  }
  play() {
    var r, i;
    if (this.isStopped)
      return;
    const { driver: e = Fn, startTime: s } = this.options;
    this.driver || (this.driver = e((a) => this.tick(a))), (i = (r = this.options).onPlay) == null || i.call(r);
    const n = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = n) : this.holdTime !== null ? this.startTime = n - this.holdTime : this.startTime || (this.startTime = s ?? n), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(j.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, s;
    this.notifyFinished(), this.teardown(), this.state = "finished", (s = (e = this.options).onComplete) == null || s.call(e);
  }
  cancel() {
    var e, s;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (s = (e = this.options).onCancel) == null || s.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var s;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (s = this.driver) == null || s.stop(), e.observe(this);
  }
}
function rr(t) {
  for (let e = 1; e < t.length; e++)
    t[e] ?? (t[e] = t[e - 1]);
}
const Tt = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], ir = /* @__PURE__ */ (() => new Set(Tt))(), ar = /* @__PURE__ */ new Set(["x", "y", "z"]), or = Tt.filter((t) => !ar.has(t));
function cr(t) {
  const e = [];
  return or.forEach((s) => {
    const n = t.getValue(s);
    n !== void 0 && (e.push([s, n.get()]), n.set(s.startsWith("scale") ? 1 : 0));
  }), e;
}
const ae = /* @__PURE__ */ new Set();
let nt = !1, rt = !1, it = !1;
function Ss() {
  if (rt) {
    const t = Array.from(ae).filter((n) => n.needsMeasurement), e = new Set(t.map((n) => n.element)), s = /* @__PURE__ */ new Map();
    e.forEach((n) => {
      const r = cr(n);
      r.length && (s.set(n, r), n.render());
    }), t.forEach((n) => n.measureInitialState()), e.forEach((n) => {
      n.render();
      const r = s.get(n);
      r && r.forEach(([i, a]) => {
        var o;
        (o = n.getValue(i)) == null || o.set(a);
      });
    }), t.forEach((n) => n.measureEndState()), t.forEach((n) => {
      n.suspendedScrollY !== void 0 && window.scrollTo(0, n.suspendedScrollY);
    });
  }
  rt = !1, nt = !1, ae.forEach((t) => t.complete(it)), ae.clear();
}
function Cs() {
  ae.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (rt = !0);
  });
}
function lr() {
  it = !0, Cs(), Ss(), it = !1;
}
class ur {
  constructor(e, s, n, r, i, a = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = s, this.name = n, this.motionValue = r, this.element = i, this.isAsync = a;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (ae.add(this), nt || (nt = !0, H.read(Cs), H.resolveKeyframes(Ss))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: s, element: n, motionValue: r } = this;
    if (e[0] === null) {
      const i = r == null ? void 0 : r.get(), a = e[e.length - 1];
      if (i !== void 0)
        e[0] = i;
      else if (n && s) {
        const o = n.readValue(s, a);
        o != null && (e[0] = o);
      }
      e[0] === void 0 && (e[0] = a), r && i === void 0 && r.set(e[0]);
    }
    rr(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), ae.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (ae.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const dr = (t) => t.startsWith("--");
function Os(t, e, s) {
  dr(e) ? t.style.setProperty(e, s) : t.style[e] = s;
}
const fr = {};
function Ms(t, e) {
  const s = /* @__PURE__ */ ts(t);
  return () => fr[e] ?? s();
}
const hr = /* @__PURE__ */ Ms(() => window.ScrollTimeline !== void 0, "scrollTimeline"), Rs = /* @__PURE__ */ Ms(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), ve = ([t, e, s, n]) => `cubic-bezier(${t}, ${e}, ${s}, ${n})`, Zt = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ ve([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ ve([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ ve([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ ve([0.33, 1.53, 0.69, 0.99])
};
function Ns(t, e) {
  if (t)
    return typeof t == "function" ? Rs() ? Ts(t, e) : "ease-out" : fs(t) ? ve(t) : Array.isArray(t) ? t.map((s) => Ns(s, e) || Zt.easeOut) : Zt[t];
}
function mr(t, e, s, { delay: n = 0, duration: r = 300, repeat: i = 0, repeatType: a = "loop", ease: o = "easeOut", times: c } = {}, l = void 0) {
  const u = {
    [e]: s
  };
  c && (u.offset = c);
  const f = Ns(o, r);
  Array.isArray(f) && (u.easing = f);
  const y = {
    delay: n,
    duration: r,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: i + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  };
  return l && (y.pseudoElement = l), t.animate(u, y);
}
function Es(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function pr({ type: t, ...e }) {
  return Es(t) && Rs() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class yr extends kt {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !e)
      return;
    const { element: s, name: n, keyframes: r, pseudoElement: i, allowFlatten: a = !1, finalKeyframe: o, onComplete: c } = e;
    this.isPseudoElement = !!i, this.allowFlatten = a, this.options = e, Q(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const l = pr(e);
    this.animation = mr(s, n, r, l, i), l.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !i) {
        const u = ze(r, this.options, o, this.speed);
        this.updateMotionValue && this.updateMotionValue(u), Os(s, n, u), this.animation.cancel();
      }
      c == null || c(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, s;
    (s = (e = this.animation).finish) == null || s.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var s, n, r;
    const e = (s = this.options) == null ? void 0 : s.element;
    !this.isPseudoElement && (e != null && e.isConnected) && ((r = (n = this.animation).commitStyles) == null || r.call(n));
  }
  get duration() {
    var s, n;
    const e = ((n = (s = this.animation.effect) == null ? void 0 : s.getComputedTiming) == null ? void 0 : n.call(s).duration) || 0;
    return /* @__PURE__ */ z(Number(e));
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ z(e);
  }
  get time() {
    return /* @__PURE__ */ z(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    const s = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ B(e), s && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(e) {
    this.manualStartTime = this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, rangeStart: s, rangeEnd: n, observe: r }) {
    var i;
    return this.allowFlatten && ((i = this.animation.effect) == null || i.updateTiming({ easing: "linear" })), this.animation.onfinish = null, e && hr() ? (this.animation.timeline = e, s && (this.animation.rangeStart = s), n && (this.animation.rangeEnd = n), ge) : r(this);
  }
}
const Is = {
  anticipate: ls,
  backInOut: cs,
  circInOut: us
};
function gr(t) {
  return t in Is;
}
function vr(t) {
  typeof t.ease == "string" && gr(t.ease) && (t.ease = Is[t.ease]);
}
const qe = 10;
class _r extends yr {
  constructor(e) {
    vr(e), As(e), super(e), e.startTime !== void 0 && e.autoplay !== !1 && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: s, onUpdate: n, onComplete: r, element: i, ...a } = this.options;
    if (!s)
      return;
    if (e !== void 0) {
      s.set(e);
      return;
    }
    const o = new Ve({
      ...a,
      autoplay: !1
    }), c = Math.max(qe, j.now() - this.startTime), l = X(0, qe, c - qe), u = o.sample(c).value, { name: f } = this.options;
    i && f && Os(i, f, u), s.setWithVelocity(o.sample(Math.max(0, c - l)).value, u, l), o.stop();
  }
}
const Pt = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(bs.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function br(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let s = 0; s < t.length; s++)
    if (t[s] !== e)
      return !0;
}
function xr(t, e, s, n) {
  const r = t[0];
  if (r === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const i = t[t.length - 1], a = Pt(r, e), o = Pt(i, e);
  return Ae(a === o, `You are trying to animate ${e} from "${r}" to "${i}". "${a ? i : r}" is not an animatable value.`, "value-not-animatable"), !a || !o ? !1 : br(t) || (s === "spring" || Es(s)) && n;
}
function at(t) {
  t.duration = 0, t.type = "keyframes";
}
const kr = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), Tr = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function wr(t) {
  for (let e = 0; e < t.length; e++)
    if (typeof t[e] == "string" && Tr.test(t[e]))
      return !0;
  return !1;
}
const Ar = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), Sr = /* @__PURE__ */ ts(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Cr(t) {
  var f;
  const { motionValue: e, name: s, repeatDelay: n, repeatType: r, damping: i, type: a, keyframes: o } = t;
  if (!(((f = e == null ? void 0 : e.owner) == null ? void 0 : f.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: l, transformTemplate: u } = e.owner.getProps();
  return Sr() && s && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (kr.has(s) || Ar.has(s) && wr(o)) && (s !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !l && !n && r !== "mirror" && i !== 0 && a !== "inertia";
}
const Or = 40;
class Mr extends kt {
  constructor({ autoplay: e = !0, delay: s = 0, type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: a = "loop", keyframes: o, name: c, motionValue: l, element: u, ...f }) {
    var M;
    super(), this.stop = () => {
      var _, x;
      this._animation && (this._animation.stop(), (_ = this.stopTimeline) == null || _.call(this)), (x = this.keyframeResolver) == null || x.cancel();
    }, this.createdAt = j.now();
    const y = {
      autoplay: e,
      delay: s,
      type: n,
      repeat: r,
      repeatDelay: i,
      repeatType: a,
      name: c,
      motionValue: l,
      element: u,
      ...f
    }, A = (u == null ? void 0 : u.KeyframeResolver) || ur;
    this.keyframeResolver = new A(o, (_, x, T) => this.onKeyframesResolved(_, x, y, !T), c, l, u), (M = this.keyframeResolver) == null || M.scheduleResolve();
  }
  onKeyframesResolved(e, s, n, r) {
    var T, D;
    this.keyframeResolver = void 0;
    const { name: i, type: a, velocity: o, delay: c, isHandoff: l, onUpdate: u } = n;
    this.resolvedAt = j.now();
    let f = !0;
    xr(e, i, a, o) || (f = !1, (ee.instantAnimations || !c) && (u == null || u(ze(e, n, s))), e[0] = e[e.length - 1], at(n), n.repeat = 0);
    const A = {
      startTime: r ? this.resolvedAt ? this.resolvedAt - this.createdAt > Or ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: s,
      ...n,
      keyframes: e
    }, M = f && !l && Cr(A), _ = (D = (T = A.motionValue) == null ? void 0 : T.owner) == null ? void 0 : D.current;
    let x;
    if (M)
      try {
        x = new _r({
          ...A,
          element: _
        });
      } catch {
        x = new Ve(A);
      }
    else
      x = new Ve(A);
    x.finished.then(() => {
      this.notifyFinished();
    }).catch(ge), this.pendingTimeline && (this.stopTimeline = x.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = x;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, s) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), lr()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
function Rr(t, e, s, n = 0, r = 1) {
  const i = Array.from(t).sort((l, u) => l.sortNodePosition(u)).indexOf(e), a = t.size, o = (a - 1) * n;
  return typeof s == "function" ? s(i, a) : r === 1 ? i * n : o - i * n;
}
const Nr = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Er = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Ir = {
  type: "keyframes",
  duration: 0.8
}, Vr = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Dr = (t, { keyframes: e }) => e.length > 2 ? Ir : ir.has(t) ? t.startsWith("scale") ? Er(e[1]) : Nr : Vr;
function Vs(t, e) {
  if (t != null && t.inherit && e) {
    const { inherit: s, ...n } = t;
    return { ...e, ...n };
  }
  return t;
}
function Ds(t, e) {
  const s = (t == null ? void 0 : t[e]) ?? (t == null ? void 0 : t.default) ?? t;
  return s !== t ? Vs(s, t) : s;
}
const Zr = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function Pr(t) {
  for (const e in t)
    if (!Zr.has(e))
      return !0;
  return !1;
}
const $r = (t, e, s, n = {}, r, i) => (a) => {
  const o = Ds(n, t) || {}, c = o.delay || n.delay || 0;
  let { elapsed: l = 0 } = n;
  l = l - /* @__PURE__ */ B(c);
  const u = {
    keyframes: Array.isArray(s) ? s : [null, s],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...o,
    delay: -l,
    onUpdate: (y) => {
      e.set(y), o.onUpdate && o.onUpdate(y);
    },
    onComplete: () => {
      a(), o.onComplete && o.onComplete();
    },
    name: t,
    motionValue: e,
    element: i ? void 0 : r
  };
  Pr(o) || Object.assign(u, Dr(t, u)), u.duration && (u.duration = /* @__PURE__ */ B(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ B(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let f = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (at(u), u.delay === 0 && (f = !0)), (ee.instantAnimations || ee.skipAnimations || r != null && r.shouldSkipAnimations) && (f = !0, at(u), u.delay = 0), u.allowFlatten = !o.type && !o.ease, f && !i && e.get() !== void 0) {
    const y = ze(u.keyframes, o);
    if (y !== void 0) {
      H.update(() => {
        u.onUpdate(y), u.onComplete();
      });
      return;
    }
  }
  return o.isSync ? new Ve(u) : new Mr(u);
};
function $t(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((s, n) => {
    e[0][n] = s.get(), e[1][n] = s.getVelocity();
  }), e;
}
function jr(t, e, s, n) {
  if (typeof e == "function") {
    const [r, i] = $t(n);
    e = e(s !== void 0 ? s : t.custom, r, i);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [r, i] = $t(n);
    e = e(s !== void 0 ? s : t.custom, r, i);
  }
  return e;
}
function wt(t, e, s) {
  const n = t.getProps();
  return jr(n, e, s !== void 0 ? s : n.custom, t);
}
const Fr = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Tt
]), jt = 30, Lr = (t) => !isNaN(parseFloat(t));
class zr {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, s = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (n) => {
      var i;
      const r = j.now();
      if (this.updatedAt !== r && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(n), this.current !== this.prev && ((i = this.events.change) == null || i.notify(this.current), this.dependents))
        for (const a of this.dependents)
          a.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = s.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = j.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = Lr(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && Xs(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, s) {
    this.events[e] || (this.events[e] = new Js());
    const n = this.events[e].add(s);
    return e === "change" ? () => {
      n(), H.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : n;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, s) {
    this.passiveEffect = e, this.stopPassiveEffect = s;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, s, n) {
    this.set(s), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - n;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, s = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, s && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = j.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > jt)
      return 0;
    const s = Math.min(this.updatedAt - this.prevUpdatedAt, jt);
    return ns(parseFloat(this.current) - parseFloat(this.prevFrameValue), s);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((s) => {
      this.hasAnimated = !0, this.animation = e(s), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, s;
    (e = this.dependents) == null || e.clear(), (s = this.events.destroy) == null || s.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Br(t, e) {
  return new zr(t, e);
}
const Ur = (t) => Array.isArray(t);
function Wr(t, e, s) {
  t.hasValue(e) ? t.getValue(e).set(s) : t.addValue(e, Br(s));
}
function Kr(t) {
  return Ur(t) ? t[t.length - 1] || 0 : t;
}
function At(t, e) {
  const s = wt(t, e);
  let { transitionEnd: n = {}, transition: r = {}, ...i } = s || {};
  i = { ...i, ...n };
  for (const a in i) {
    const o = Kr(i[a]);
    Wr(t, a, o);
  }
}
const qr = (t) => !!(t && t.getVelocity);
function Gr(t) {
  return !!(qr(t) && t.add);
}
function Yr(t, e) {
  const s = t.getValue("willChange");
  if (Gr(s))
    return s.add(e);
  if (!s && ee.WillChange) {
    const n = new ee.WillChange("auto");
    t.addValue("willChange", n), n.add(e);
  }
}
function Hr(t) {
  return t.replace(/([A-Z])/g, (e) => `-${e.toLowerCase()}`);
}
const Jr = "framerAppearId", Xr = "data-" + Hr(Jr);
function Qr(t) {
  return t.props[Xr];
}
function ei({ protectedKeys: t, needsAnimating: e }, s) {
  const n = t.hasOwnProperty(s) && e[s] !== !0;
  return e[s] = !1, n;
}
function Zs(t, e, { delay: s = 0, transitionOverride: n, type: r } = {}) {
  let { transition: i, transitionEnd: a, ...o } = e;
  const c = t.getDefaultTransition();
  i = i ? Vs(i, c) : c;
  const l = i == null ? void 0 : i.reduceMotion;
  n && (i = n);
  const u = [], f = r && t.animationState && t.animationState.getState()[r];
  for (const y in o) {
    const A = t.getValue(y, t.latestValues[y] ?? null), M = o[y];
    if (M === void 0 || f && ei(f, y))
      continue;
    const _ = {
      delay: s,
      ...Ds(i || {}, y)
    }, x = A.get();
    if (x !== void 0 && !A.isAnimating() && !Array.isArray(M) && M === x && !_.velocity) {
      H.update(() => A.set(M));
      continue;
    }
    let T = !1;
    if (window.MotionHandoffAnimation) {
      const R = Qr(t);
      if (R) {
        const O = window.MotionHandoffAnimation(R, y, H);
        O !== null && (_.startTime = O, T = !0);
      }
    }
    Yr(t, y);
    const D = l ?? t.shouldReduceMotion;
    A.start($r(y, A, M, D && Fr.has(y) ? { type: !1 } : _, t, T));
    const N = A.animation;
    N && u.push(N);
  }
  if (a) {
    const y = () => H.update(() => {
      a && At(t, a);
    });
    u.length ? Promise.all(u).then(y) : y();
  }
  return u;
}
function ot(t, e, s = {}) {
  var c;
  const n = wt(t, e, s.type === "exit" ? (c = t.presenceContext) == null ? void 0 : c.custom : void 0);
  let { transition: r = t.getDefaultTransition() || {} } = n || {};
  s.transitionOverride && (r = s.transitionOverride);
  const i = n ? () => Promise.all(Zs(t, n, s)) : () => Promise.resolve(), a = t.variantChildren && t.variantChildren.size ? (l = 0) => {
    const { delayChildren: u = 0, staggerChildren: f, staggerDirection: y } = r;
    return ti(t, e, l, u, f, y, s);
  } : () => Promise.resolve(), { when: o } = r;
  if (o) {
    const [l, u] = o === "beforeChildren" ? [i, a] : [a, i];
    return l().then(() => u());
  } else
    return Promise.all([i(), a(s.delay)]);
}
function ti(t, e, s = 0, n = 0, r = 0, i = 1, a) {
  const o = [];
  for (const c of t.variantChildren)
    c.notify("AnimationStart", e), o.push(ot(c, e, {
      ...a,
      delay: s + (typeof n == "function" ? 0 : n) + Rr(t.variantChildren, c, n, r, i)
    }).then(() => c.notify("AnimationComplete", e)));
  return Promise.all(o);
}
function si(t, e, s = {}) {
  t.notify("AnimationStart", e);
  let n;
  if (Array.isArray(e)) {
    const r = e.map((i) => ot(t, i, s));
    n = Promise.all(r);
  } else if (typeof e == "string")
    n = ot(t, e, s);
  else {
    const r = typeof e == "function" ? wt(t, e, s.custom) : e;
    n = Promise.all(Zs(t, r, s));
  }
  return n.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function ni(t) {
  t.values.forEach((e) => e.stop());
}
function ct(t, e) {
  [...e].reverse().forEach((n) => {
    const r = t.getVariant(n);
    r && At(t, r), t.variantChildren && t.variantChildren.forEach((i) => {
      ct(i, e);
    });
  });
}
function ri(t, e) {
  if (Array.isArray(e))
    return ct(t, e);
  if (typeof e == "string")
    return ct(t, [e]);
  At(t, e);
}
function ii() {
  let t = !1;
  const e = /* @__PURE__ */ new Set(), s = {
    subscribe(n) {
      return e.add(n), () => void e.delete(n);
    },
    start(n, r) {
      Q(t, "controls.start() should only be called after a component has mounted. Consider calling within a useEffect hook.");
      const i = [];
      return e.forEach((a) => {
        i.push(si(a, n, {
          transitionOverride: r
        }));
      }), Promise.all(i);
    },
    set(n) {
      return Q(t, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook."), e.forEach((r) => {
        ri(r, n);
      });
    },
    stop() {
      e.forEach((n) => {
        ni(n);
      });
    },
    mount() {
      return t = !0, () => {
        t = !1, s.stop();
      };
    }
  };
  return s;
}
function ai() {
  const t = Ws(ii);
  return qs(t.mount, []), t;
}
const oi = ai, Ps = "(prefers-reduced-motion: no-preference)", ci = typeof window > "u", li = () => ci ? !0 : !window.matchMedia(Ps).matches, ui = () => {
  const [t, e] = Fe(li);
  return oe(() => {
    const s = window.matchMedia(Ps), n = (r) => {
      e(!r.matches);
    };
    return s.addEventListener && s.addEventListener("change", n), () => {
      s.removeEventListener && s.removeEventListener("change", n);
    };
  }, []), t;
}, Gi = ({
  x: t = 0,
  y: e = 0,
  rotation: s = 0,
  scale: n = 1,
  timing: r = 150,
  springConfig: i = {
    stiffness: 300,
    damping: 10,
    mass: 1
  }
}) => {
  const a = ui(), [o, c] = Fe(!1), l = oi();
  oe(() => {
    o ? l.start({
      display: "inline-block",
      transform: `translate(${t}px, ${e}px) rotate(${s}deg) scale(${n})`,
      transition: { type: "spring", ...i }
    }) : l.start({
      display: "inline-block",
      transform: "translate(0px, 0px) rotate(0deg) scale(1)",
      transition: { type: "spring", ...i }
    });
  }, [o]), oe(() => {
    if (!o)
      return;
    const y = window.setTimeout(() => {
      c(!1);
    }, r);
    return () => {
      window.clearTimeout(y);
    };
  }, [o]);
  const u = Bs(() => {
    c(!0);
  }, []);
  return [a ? {} : l, u];
};
var S;
(function(t) {
  t.assertEqual = (r) => {
  };
  function e(r) {
  }
  t.assertIs = e;
  function s(r) {
    throw new Error();
  }
  t.assertNever = s, t.arrayToEnum = (r) => {
    const i = {};
    for (const a of r)
      i[a] = a;
    return i;
  }, t.getValidEnumValues = (r) => {
    const i = t.objectKeys(r).filter((o) => typeof r[r[o]] != "number"), a = {};
    for (const o of i)
      a[o] = r[o];
    return t.objectValues(a);
  }, t.objectValues = (r) => t.objectKeys(r).map(function(i) {
    return r[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (r) => Object.keys(r) : (r) => {
    const i = [];
    for (const a in r)
      Object.prototype.hasOwnProperty.call(r, a) && i.push(a);
    return i;
  }, t.find = (r, i) => {
    for (const a of r)
      if (i(a))
        return a;
  }, t.isInteger = typeof Number.isInteger == "function" ? (r) => Number.isInteger(r) : (r) => typeof r == "number" && Number.isFinite(r) && Math.floor(r) === r;
  function n(r, i = " | ") {
    return r.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (r, i) => typeof i == "bigint" ? i.toString() : i;
})(S || (S = {}));
var Ft;
(function(t) {
  t.mergeShapes = (e, s) => ({
    ...e,
    ...s
    // second overwrites first
  });
})(Ft || (Ft = {}));
const m = S.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Y = (t) => {
  switch (typeof t) {
    case "undefined":
      return m.undefined;
    case "string":
      return m.string;
    case "number":
      return Number.isNaN(t) ? m.nan : m.number;
    case "boolean":
      return m.boolean;
    case "function":
      return m.function;
    case "bigint":
      return m.bigint;
    case "symbol":
      return m.symbol;
    case "object":
      return Array.isArray(t) ? m.array : t === null ? m.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? m.promise : typeof Map < "u" && t instanceof Map ? m.map : typeof Set < "u" && t instanceof Set ? m.set : typeof Date < "u" && t instanceof Date ? m.date : m.object;
    default:
      return m.unknown;
  }
}, d = S.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class K extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const s = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, s) : this.__proto__ = s, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const s = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, r = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(r);
        else if (a.code === "invalid_return_type")
          r(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          r(a.argumentsError);
        else if (a.path.length === 0)
          n._errors.push(s(a));
        else {
          let o = n, c = 0;
          for (; c < a.path.length; ) {
            const l = a.path[c];
            c === a.path.length - 1 ? (o[l] = o[l] || { _errors: [] }, o[l]._errors.push(s(a))) : o[l] = o[l] || { _errors: [] }, o = o[l], c++;
          }
        }
    };
    return r(this), n;
  }
  static assert(e) {
    if (!(e instanceof K))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, S.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (s) => s.message) {
    const s = {}, n = [];
    for (const r of this.issues)
      if (r.path.length > 0) {
        const i = r.path[0];
        s[i] = s[i] || [], s[i].push(e(r));
      } else
        n.push(e(r));
    return { formErrors: n, fieldErrors: s };
  }
  get formErrors() {
    return this.flatten();
  }
}
K.create = (t) => new K(t);
const di = (t, e) => {
  let s;
  switch (t.code) {
    case d.invalid_type:
      t.received === m.undefined ? s = "Required" : s = `Expected ${t.expected}, received ${t.received}`;
      break;
    case d.invalid_literal:
      s = `Invalid literal value, expected ${JSON.stringify(t.expected, S.jsonStringifyReplacer)}`;
      break;
    case d.unrecognized_keys:
      s = `Unrecognized key(s) in object: ${S.joinValues(t.keys, ", ")}`;
      break;
    case d.invalid_union:
      s = "Invalid input";
      break;
    case d.invalid_union_discriminator:
      s = `Invalid discriminator value. Expected ${S.joinValues(t.options)}`;
      break;
    case d.invalid_enum_value:
      s = `Invalid enum value. Expected ${S.joinValues(t.options)}, received '${t.received}'`;
      break;
    case d.invalid_arguments:
      s = "Invalid function arguments";
      break;
    case d.invalid_return_type:
      s = "Invalid function return type";
      break;
    case d.invalid_date:
      s = "Invalid date";
      break;
    case d.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (s = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (s = `${s} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? s = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? s = `Invalid input: must end with "${t.validation.endsWith}"` : S.assertNever(t.validation) : t.validation !== "regex" ? s = `Invalid ${t.validation}` : s = "Invalid";
      break;
    case d.too_small:
      t.type === "array" ? s = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? s = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? s = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "bigint" ? s = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? s = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : s = "Invalid input";
      break;
    case d.too_big:
      t.type === "array" ? s = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? s = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? s = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? s = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? s = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : s = "Invalid input";
      break;
    case d.custom:
      s = "Invalid input";
      break;
    case d.invalid_intersection_types:
      s = "Intersection results could not be merged";
      break;
    case d.not_multiple_of:
      s = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case d.not_finite:
      s = "Number must be finite";
      break;
    default:
      s = e.defaultError, S.assertNever(t);
  }
  return { message: s };
}, lt = di;
let fi = lt;
function hi() {
  return fi;
}
const mi = (t) => {
  const { data: e, path: s, errorMaps: n, issueData: r } = t, i = [...s, ...r.path || []], a = {
    ...r,
    path: i
  };
  if (r.message !== void 0)
    return {
      ...r,
      path: i,
      message: r.message
    };
  let o = "";
  const c = n.filter((l) => !!l).slice().reverse();
  for (const l of c)
    o = l(a, { data: e, defaultError: o }).message;
  return {
    ...r,
    path: i,
    message: o
  };
};
function h(t, e) {
  const s = hi(), n = mi({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      s,
      // then global override map
      s === lt ? void 0 : lt
      // then global default map
    ].filter((r) => !!r)
  });
  t.common.issues.push(n);
}
class $ {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, s) {
    const n = [];
    for (const r of s) {
      if (r.status === "aborted")
        return g;
      r.status === "dirty" && e.dirty(), n.push(r.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, s) {
    const n = [];
    for (const r of s) {
      const i = await r.key, a = await r.value;
      n.push({
        key: i,
        value: a
      });
    }
    return $.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, s) {
    const n = {};
    for (const r of s) {
      const { key: i, value: a } = r;
      if (i.status === "aborted" || a.status === "aborted")
        return g;
      i.status === "dirty" && e.dirty(), a.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || r.alwaysSet) && (n[i.value] = a.value);
    }
    return { status: e.value, value: n };
  }
}
const g = Object.freeze({
  status: "aborted"
}), _e = (t) => ({ status: "dirty", value: t }), F = (t) => ({ status: "valid", value: t }), Lt = (t) => t.status === "aborted", zt = (t) => t.status === "dirty", he = (t) => t.status === "valid", De = (t) => typeof Promise < "u" && t instanceof Promise;
var p;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(p || (p = {}));
class te {
  constructor(e, s, n, r) {
    this._cachedPath = [], this.parent = e, this.data = s, this._path = n, this._key = r;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Bt = (t, e) => {
  if (he(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const s = new K(t.common.issues);
      return this._error = s, this._error;
    }
  };
};
function k(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: s, required_error: n, description: r } = t;
  if (e && (s || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: r } : { errorMap: (a, o) => {
    const { message: c } = t;
    return a.code === "invalid_enum_value" ? { message: c ?? o.defaultError } : typeof o.data > "u" ? { message: c ?? n ?? o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: c ?? s ?? o.defaultError };
  }, description: r };
}
class w {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Y(e.data);
  }
  _getOrReturnCtx(e, s) {
    return s || {
      common: e.parent.common,
      data: e.data,
      parsedType: Y(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new $(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Y(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const s = this._parse(e);
    if (De(s))
      throw new Error("Synchronous parse encountered promise.");
    return s;
  }
  _parseAsync(e) {
    const s = this._parse(e);
    return Promise.resolve(s);
  }
  parse(e, s) {
    const n = this.safeParse(e, s);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, s) {
    const n = {
      common: {
        issues: [],
        async: (s == null ? void 0 : s.async) ?? !1,
        contextualErrorMap: s == null ? void 0 : s.errorMap
      },
      path: (s == null ? void 0 : s.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Y(e)
    }, r = this._parseSync({ data: e, path: n.path, parent: n });
    return Bt(n, r);
  }
  "~validate"(e) {
    var n, r;
    const s = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Y(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: s });
        return he(i) ? {
          value: i.value
        } : {
          issues: s.common.issues
        };
      } catch (i) {
        (r = (n = i == null ? void 0 : i.message) == null ? void 0 : n.toLowerCase()) != null && r.includes("encountered") && (this["~standard"].async = !0), s.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: s }).then((i) => he(i) ? {
      value: i.value
    } : {
      issues: s.common.issues
    });
  }
  async parseAsync(e, s) {
    const n = await this.safeParseAsync(e, s);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, s) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: s == null ? void 0 : s.errorMap,
        async: !0
      },
      path: (s == null ? void 0 : s.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Y(e)
    }, r = this._parse({ data: e, path: n.path, parent: n }), i = await (De(r) ? r : Promise.resolve(r));
    return Bt(n, i);
  }
  refine(e, s) {
    const n = (r) => typeof s == "string" || typeof s > "u" ? { message: s } : typeof s == "function" ? s(r) : s;
    return this._refinement((r, i) => {
      const a = e(r), o = () => i.addIssue({
        code: d.custom,
        ...n(r)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((c) => c ? !0 : (o(), !1)) : a ? !0 : (o(), !1);
    });
  }
  refinement(e, s) {
    return this._refinement((n, r) => e(n) ? !0 : (r.addIssue(typeof s == "function" ? s(n, r) : s), !1));
  }
  _refinement(e) {
    return new pe({
      schema: this,
      typeName: v.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (s) => this["~validate"](s)
    };
  }
  optional() {
    return J.create(this, this._def);
  }
  nullable() {
    return ye.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return U.create(this);
  }
  promise() {
    return je.create(this, this._def);
  }
  or(e) {
    return Pe.create([this, e], this._def);
  }
  and(e) {
    return $e.create(this, e, this._def);
  }
  transform(e) {
    return new pe({
      ...k(this._def),
      schema: this,
      typeName: v.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const s = typeof e == "function" ? e : () => e;
    return new ht({
      ...k(this._def),
      innerType: this,
      defaultValue: s,
      typeName: v.ZodDefault
    });
  }
  brand() {
    return new Pi({
      typeName: v.ZodBranded,
      type: this,
      ...k(this._def)
    });
  }
  catch(e) {
    const s = typeof e == "function" ? e : () => e;
    return new mt({
      ...k(this._def),
      innerType: this,
      catchValue: s,
      typeName: v.ZodCatch
    });
  }
  describe(e) {
    const s = this.constructor;
    return new s({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return St.create(this, e);
  }
  readonly() {
    return pt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const pi = /^c[^\s-]{8,}$/i, yi = /^[0-9a-z]+$/, gi = /^[0-9A-HJKMNP-TV-Z]{26}$/i, vi = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, _i = /^[a-z0-9_-]{21}$/i, bi = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, xi = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, ki = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Ti = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ge;
const wi = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ai = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Si = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Ci = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Oi = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Mi = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, $s = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ri = new RegExp(`^${$s}$`);
function js(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const s = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${s}`;
}
function Ni(t) {
  return new RegExp(`^${js(t)}$`);
}
function Ei(t) {
  let e = `${$s}T${js(t)}`;
  const s = [];
  return s.push(t.local ? "Z?" : "Z"), t.offset && s.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${s.join("|")})`, new RegExp(`^${e}$`);
}
function Ii(t, e) {
  return !!((e === "v4" || !e) && wi.test(t) || (e === "v6" || !e) && Si.test(t));
}
function Vi(t, e) {
  if (!bi.test(t))
    return !1;
  try {
    const [s] = t.split(".");
    if (!s)
      return !1;
    const n = s.replace(/-/g, "+").replace(/_/g, "/").padEnd(s.length + (4 - s.length % 4) % 4, "="), r = JSON.parse(atob(n));
    return !(typeof r != "object" || r === null || "typ" in r && (r == null ? void 0 : r.typ) !== "JWT" || !r.alg || e && r.alg !== e);
  } catch {
    return !1;
  }
}
function Di(t, e) {
  return !!((e === "v4" || !e) && Ai.test(t) || (e === "v6" || !e) && Ci.test(t));
}
class ie extends w {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== m.string) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: d.invalid_type,
        expected: m.string,
        received: i.parsedType
      }), g;
    }
    const n = new $();
    let r;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const a = e.data.length > i.value, o = e.data.length < i.value;
        (a || o) && (r = this._getOrReturnCtx(e, r), a ? h(r, {
          code: d.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && h(r, {
          code: d.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        ki.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "email",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        Ge || (Ge = new RegExp(Ti, "u")), Ge.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "emoji",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        vi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "uuid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        _i.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "nanoid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        pi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "cuid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        yi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "cuid2",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        gi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "ulid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          r = this._getOrReturnCtx(e, r), h(r, {
            validation: "url",
            code: d.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else
        i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "regex",
          code: d.invalid_string,
          message: i.message
        }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: { includes: i.value, position: i.position },
          message: i.message
        }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: { startsWith: i.value },
          message: i.message
        }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: { endsWith: i.value },
          message: i.message
        }), n.dirty()) : i.kind === "datetime" ? Ei(i).test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: "datetime",
          message: i.message
        }), n.dirty()) : i.kind === "date" ? Ri.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: "date",
          message: i.message
        }), n.dirty()) : i.kind === "time" ? Ni(i).test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          code: d.invalid_string,
          validation: "time",
          message: i.message
        }), n.dirty()) : i.kind === "duration" ? xi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "duration",
          code: d.invalid_string,
          message: i.message
        }), n.dirty()) : i.kind === "ip" ? Ii(e.data, i.version) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "ip",
          code: d.invalid_string,
          message: i.message
        }), n.dirty()) : i.kind === "jwt" ? Vi(e.data, i.alg) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "jwt",
          code: d.invalid_string,
          message: i.message
        }), n.dirty()) : i.kind === "cidr" ? Di(e.data, i.version) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "cidr",
          code: d.invalid_string,
          message: i.message
        }), n.dirty()) : i.kind === "base64" ? Oi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "base64",
          code: d.invalid_string,
          message: i.message
        }), n.dirty()) : i.kind === "base64url" ? Mi.test(e.data) || (r = this._getOrReturnCtx(e, r), h(r, {
          validation: "base64url",
          code: d.invalid_string,
          message: i.message
        }), n.dirty()) : S.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, s, n) {
    return this.refinement((r) => e.test(r), {
      validation: s,
      code: d.invalid_string,
      ...p.errToObj(n)
    });
  }
  _addCheck(e) {
    return new ie({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...p.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...p.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...p.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...p.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...p.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...p.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...p.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...p.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...p.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...p.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...p.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...p.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...p.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...p.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...p.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...p.errToObj(e) });
  }
  regex(e, s) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...p.errToObj(s)
    });
  }
  includes(e, s) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: s == null ? void 0 : s.position,
      ...p.errToObj(s == null ? void 0 : s.message)
    });
  }
  startsWith(e, s) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...p.errToObj(s)
    });
  }
  endsWith(e, s) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...p.errToObj(s)
    });
  }
  min(e, s) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...p.errToObj(s)
    });
  }
  max(e, s) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...p.errToObj(s)
    });
  }
  length(e, s) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...p.errToObj(s)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, p.errToObj(e));
  }
  trim() {
    return new ie({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ie({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ie({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const s of this._def.checks)
      s.kind === "min" && (e === null || s.value > e) && (e = s.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const s of this._def.checks)
      s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    return e;
  }
}
ie.create = (t) => new ie({
  checks: [],
  typeName: v.ZodString,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...k(t)
});
function Zi(t, e) {
  const s = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, r = s > n ? s : n, i = Number.parseInt(t.toFixed(r).replace(".", "")), a = Number.parseInt(e.toFixed(r).replace(".", ""));
  return i % a / 10 ** r;
}
class ke extends w {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== m.number) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: d.invalid_type,
        expected: m.number,
        received: i.parsedType
      }), g;
    }
    let n;
    const r = new $();
    for (const i of this._def.checks)
      i.kind === "int" ? S.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), r.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? Zi(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.not_finite,
        message: i.message
      }), r.dirty()) : S.assertNever(i);
    return { status: r.value, value: e.data };
  }
  gte(e, s) {
    return this.setLimit("min", e, !0, p.toString(s));
  }
  gt(e, s) {
    return this.setLimit("min", e, !1, p.toString(s));
  }
  lte(e, s) {
    return this.setLimit("max", e, !0, p.toString(s));
  }
  lt(e, s) {
    return this.setLimit("max", e, !1, p.toString(s));
  }
  setLimit(e, s, n, r) {
    return new ke({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: s,
          inclusive: n,
          message: p.toString(r)
        }
      ]
    });
  }
  _addCheck(e) {
    return new ke({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: p.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, s) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(s)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: p.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: p.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: p.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const s of this._def.checks)
      s.kind === "min" && (e === null || s.value > e) && (e = s.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const s of this._def.checks)
      s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && S.isInteger(e.value));
  }
  get isFinite() {
    let e = null, s = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (s === null || n.value > s) && (s = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(s) && Number.isFinite(e);
  }
}
ke.create = (t) => new ke({
  checks: [],
  typeName: v.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...k(t)
});
class Te extends w {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== m.bigint)
      return this._getInvalidInput(e);
    let n;
    const r = new $();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), r.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: d.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), r.dirty()) : S.assertNever(i);
    return { status: r.value, value: e.data };
  }
  _getInvalidInput(e) {
    const s = this._getOrReturnCtx(e);
    return h(s, {
      code: d.invalid_type,
      expected: m.bigint,
      received: s.parsedType
    }), g;
  }
  gte(e, s) {
    return this.setLimit("min", e, !0, p.toString(s));
  }
  gt(e, s) {
    return this.setLimit("min", e, !1, p.toString(s));
  }
  lte(e, s) {
    return this.setLimit("max", e, !0, p.toString(s));
  }
  lt(e, s) {
    return this.setLimit("max", e, !1, p.toString(s));
  }
  setLimit(e, s, n, r) {
    return new Te({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: s,
          inclusive: n,
          message: p.toString(r)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Te({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, s) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(s)
    });
  }
  get minValue() {
    let e = null;
    for (const s of this._def.checks)
      s.kind === "min" && (e === null || s.value > e) && (e = s.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const s of this._def.checks)
      s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    return e;
  }
}
Te.create = (t) => new Te({
  checks: [],
  typeName: v.ZodBigInt,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...k(t)
});
class ut extends w {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== m.boolean) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: m.boolean,
        received: n.parsedType
      }), g;
    }
    return F(e.data);
  }
}
ut.create = (t) => new ut({
  typeName: v.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...k(t)
});
class Ze extends w {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== m.date) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: d.invalid_type,
        expected: m.date,
        received: i.parsedType
      }), g;
    }
    if (Number.isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return h(i, {
        code: d.invalid_date
      }), g;
    }
    const n = new $();
    let r;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (r = this._getOrReturnCtx(e, r), h(r, {
        code: d.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (r = this._getOrReturnCtx(e, r), h(r, {
        code: d.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : S.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Ze({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, s) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: p.toString(s)
    });
  }
  max(e, s) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: p.toString(s)
    });
  }
  get minDate() {
    let e = null;
    for (const s of this._def.checks)
      s.kind === "min" && (e === null || s.value > e) && (e = s.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const s of this._def.checks)
      s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    return e != null ? new Date(e) : null;
  }
}
Ze.create = (t) => new Ze({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: v.ZodDate,
  ...k(t)
});
class Ut extends w {
  _parse(e) {
    if (this._getType(e) !== m.symbol) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: m.symbol,
        received: n.parsedType
      }), g;
    }
    return F(e.data);
  }
}
Ut.create = (t) => new Ut({
  typeName: v.ZodSymbol,
  ...k(t)
});
class Wt extends w {
  _parse(e) {
    if (this._getType(e) !== m.undefined) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: m.undefined,
        received: n.parsedType
      }), g;
    }
    return F(e.data);
  }
}
Wt.create = (t) => new Wt({
  typeName: v.ZodUndefined,
  ...k(t)
});
class Kt extends w {
  _parse(e) {
    if (this._getType(e) !== m.null) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: m.null,
        received: n.parsedType
      }), g;
    }
    return F(e.data);
  }
}
Kt.create = (t) => new Kt({
  typeName: v.ZodNull,
  ...k(t)
});
class qt extends w {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return F(e.data);
  }
}
qt.create = (t) => new qt({
  typeName: v.ZodAny,
  ...k(t)
});
class Gt extends w {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return F(e.data);
  }
}
Gt.create = (t) => new Gt({
  typeName: v.ZodUnknown,
  ...k(t)
});
class se extends w {
  _parse(e) {
    const s = this._getOrReturnCtx(e);
    return h(s, {
      code: d.invalid_type,
      expected: m.never,
      received: s.parsedType
    }), g;
  }
}
se.create = (t) => new se({
  typeName: v.ZodNever,
  ...k(t)
});
class Yt extends w {
  _parse(e) {
    if (this._getType(e) !== m.undefined) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: m.void,
        received: n.parsedType
      }), g;
    }
    return F(e.data);
  }
}
Yt.create = (t) => new Yt({
  typeName: v.ZodVoid,
  ...k(t)
});
class U extends w {
  _parse(e) {
    const { ctx: s, status: n } = this._processInputParams(e), r = this._def;
    if (s.parsedType !== m.array)
      return h(s, {
        code: d.invalid_type,
        expected: m.array,
        received: s.parsedType
      }), g;
    if (r.exactLength !== null) {
      const a = s.data.length > r.exactLength.value, o = s.data.length < r.exactLength.value;
      (a || o) && (h(s, {
        code: a ? d.too_big : d.too_small,
        minimum: o ? r.exactLength.value : void 0,
        maximum: a ? r.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: r.exactLength.message
      }), n.dirty());
    }
    if (r.minLength !== null && s.data.length < r.minLength.value && (h(s, {
      code: d.too_small,
      minimum: r.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.minLength.message
    }), n.dirty()), r.maxLength !== null && s.data.length > r.maxLength.value && (h(s, {
      code: d.too_big,
      maximum: r.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.maxLength.message
    }), n.dirty()), s.common.async)
      return Promise.all([...s.data].map((a, o) => r.type._parseAsync(new te(s, a, s.path, o)))).then((a) => $.mergeArray(n, a));
    const i = [...s.data].map((a, o) => r.type._parseSync(new te(s, a, s.path, o)));
    return $.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, s) {
    return new U({
      ...this._def,
      minLength: { value: e, message: p.toString(s) }
    });
  }
  max(e, s) {
    return new U({
      ...this._def,
      maxLength: { value: e, message: p.toString(s) }
    });
  }
  length(e, s) {
    return new U({
      ...this._def,
      exactLength: { value: e, message: p.toString(s) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
U.create = (t, e) => new U({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: v.ZodArray,
  ...k(e)
});
function ue(t) {
  if (t instanceof I) {
    const e = {};
    for (const s in t.shape) {
      const n = t.shape[s];
      e[s] = J.create(ue(n));
    }
    return new I({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof U ? new U({
      ...t._def,
      type: ue(t.element)
    }) : t instanceof J ? J.create(ue(t.unwrap())) : t instanceof ye ? ye.create(ue(t.unwrap())) : t instanceof ce ? ce.create(t.items.map((e) => ue(e))) : t;
}
class I extends w {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), s = S.objectKeys(e);
    return this._cached = { shape: e, keys: s }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== m.object) {
      const l = this._getOrReturnCtx(e);
      return h(l, {
        code: d.invalid_type,
        expected: m.object,
        received: l.parsedType
      }), g;
    }
    const { status: n, ctx: r } = this._processInputParams(e), { shape: i, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof se && this._def.unknownKeys === "strip"))
      for (const l in r.data)
        a.includes(l) || o.push(l);
    const c = [];
    for (const l of a) {
      const u = i[l], f = r.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: u._parse(new te(r, f, r.path, l)),
        alwaysSet: l in r.data
      });
    }
    if (this._def.catchall instanceof se) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const u of o)
          c.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: r.data[u] }
          });
      else if (l === "strict")
        o.length > 0 && (h(r, {
          code: d.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (l !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const u of o) {
        const f = r.data[u];
        c.push({
          key: { status: "valid", value: u },
          value: l._parse(
            new te(r, f, r.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const u of c) {
        const f = await u.key, y = await u.value;
        l.push({
          key: f,
          value: y,
          alwaysSet: u.alwaysSet
        });
      }
      return l;
    }).then((l) => $.mergeObjectSync(n, l)) : $.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return p.errToObj, new I({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (s, n) => {
          var i, a;
          const r = ((a = (i = this._def).errorMap) == null ? void 0 : a.call(i, s, n).message) ?? n.defaultError;
          return s.code === "unrecognized_keys" ? {
            message: p.errToObj(e).message ?? r
          } : {
            message: r
          };
        }
      } : {}
    });
  }
  strip() {
    return new I({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new I({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new I({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new I({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: v.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, s) {
    return this.augment({ [e]: s });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new I({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const s = {};
    for (const n of S.objectKeys(e))
      e[n] && this.shape[n] && (s[n] = this.shape[n]);
    return new I({
      ...this._def,
      shape: () => s
    });
  }
  omit(e) {
    const s = {};
    for (const n of S.objectKeys(this.shape))
      e[n] || (s[n] = this.shape[n]);
    return new I({
      ...this._def,
      shape: () => s
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ue(this);
  }
  partial(e) {
    const s = {};
    for (const n of S.objectKeys(this.shape)) {
      const r = this.shape[n];
      e && !e[n] ? s[n] = r : s[n] = r.optional();
    }
    return new I({
      ...this._def,
      shape: () => s
    });
  }
  required(e) {
    const s = {};
    for (const n of S.objectKeys(this.shape))
      if (e && !e[n])
        s[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof J; )
          i = i._def.innerType;
        s[n] = i;
      }
    return new I({
      ...this._def,
      shape: () => s
    });
  }
  keyof() {
    return Fs(S.objectKeys(this.shape));
  }
}
I.create = (t, e) => new I({
  shape: () => t,
  unknownKeys: "strip",
  catchall: se.create(),
  typeName: v.ZodObject,
  ...k(e)
});
I.strictCreate = (t, e) => new I({
  shape: () => t,
  unknownKeys: "strict",
  catchall: se.create(),
  typeName: v.ZodObject,
  ...k(e)
});
I.lazycreate = (t, e) => new I({
  shape: t,
  unknownKeys: "strip",
  catchall: se.create(),
  typeName: v.ZodObject,
  ...k(e)
});
class Pe extends w {
  _parse(e) {
    const { ctx: s } = this._processInputParams(e), n = this._def.options;
    function r(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return s.common.issues.push(...o.ctx.common.issues), o.result;
      const a = i.map((o) => new K(o.ctx.common.issues));
      return h(s, {
        code: d.invalid_union,
        unionErrors: a
      }), g;
    }
    if (s.common.async)
      return Promise.all(n.map(async (i) => {
        const a = {
          ...s,
          common: {
            ...s.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: s.data,
            path: s.path,
            parent: a
          }),
          ctx: a
        };
      })).then(r);
    {
      let i;
      const a = [];
      for (const c of n) {
        const l = {
          ...s,
          common: {
            ...s.common,
            issues: []
          },
          parent: null
        }, u = c._parseSync({
          data: s.data,
          path: s.path,
          parent: l
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: l }), l.common.issues.length && a.push(l.common.issues);
      }
      if (i)
        return s.common.issues.push(...i.ctx.common.issues), i.result;
      const o = a.map((c) => new K(c));
      return h(s, {
        code: d.invalid_union,
        unionErrors: o
      }), g;
    }
  }
  get options() {
    return this._def.options;
  }
}
Pe.create = (t, e) => new Pe({
  options: t,
  typeName: v.ZodUnion,
  ...k(e)
});
function dt(t, e) {
  const s = Y(t), n = Y(e);
  if (t === e)
    return { valid: !0, data: t };
  if (s === m.object && n === m.object) {
    const r = S.objectKeys(e), i = S.objectKeys(t).filter((o) => r.indexOf(o) !== -1), a = { ...t, ...e };
    for (const o of i) {
      const c = dt(t[o], e[o]);
      if (!c.valid)
        return { valid: !1 };
      a[o] = c.data;
    }
    return { valid: !0, data: a };
  } else if (s === m.array && n === m.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const r = [];
    for (let i = 0; i < t.length; i++) {
      const a = t[i], o = e[i], c = dt(a, o);
      if (!c.valid)
        return { valid: !1 };
      r.push(c.data);
    }
    return { valid: !0, data: r };
  } else
    return s === m.date && n === m.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class $e extends w {
  _parse(e) {
    const { status: s, ctx: n } = this._processInputParams(e), r = (i, a) => {
      if (Lt(i) || Lt(a))
        return g;
      const o = dt(i.value, a.value);
      return o.valid ? ((zt(i) || zt(a)) && s.dirty(), { status: s.value, value: o.data }) : (h(n, {
        code: d.invalid_intersection_types
      }), g);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, a]) => r(i, a)) : r(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
$e.create = (t, e, s) => new $e({
  left: t,
  right: e,
  typeName: v.ZodIntersection,
  ...k(s)
});
class ce extends w {
  _parse(e) {
    const { status: s, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== m.array)
      return h(n, {
        code: d.invalid_type,
        expected: m.array,
        received: n.parsedType
      }), g;
    if (n.data.length < this._def.items.length)
      return h(n, {
        code: d.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), g;
    !this._def.rest && n.data.length > this._def.items.length && (h(n, {
      code: d.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), s.dirty());
    const i = [...n.data].map((a, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new te(n, a, n.path, o)) : null;
    }).filter((a) => !!a);
    return n.common.async ? Promise.all(i).then((a) => $.mergeArray(s, a)) : $.mergeArray(s, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new ce({
      ...this._def,
      rest: e
    });
  }
}
ce.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ce({
    items: t,
    typeName: v.ZodTuple,
    rest: null,
    ...k(e)
  });
};
class Ht extends w {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: s, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== m.map)
      return h(n, {
        code: d.invalid_type,
        expected: m.map,
        received: n.parsedType
      }), g;
    const r = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([o, c], l) => ({
      key: r._parse(new te(n, o, n.path, [l, "key"])),
      value: i._parse(new te(n, c, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of a) {
          const l = await c.key, u = await c.value;
          if (l.status === "aborted" || u.status === "aborted")
            return g;
          (l.status === "dirty" || u.status === "dirty") && s.dirty(), o.set(l.value, u.value);
        }
        return { status: s.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of a) {
        const l = c.key, u = c.value;
        if (l.status === "aborted" || u.status === "aborted")
          return g;
        (l.status === "dirty" || u.status === "dirty") && s.dirty(), o.set(l.value, u.value);
      }
      return { status: s.value, value: o };
    }
  }
}
Ht.create = (t, e, s) => new Ht({
  valueType: e,
  keyType: t,
  typeName: v.ZodMap,
  ...k(s)
});
class we extends w {
  _parse(e) {
    const { status: s, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== m.set)
      return h(n, {
        code: d.invalid_type,
        expected: m.set,
        received: n.parsedType
      }), g;
    const r = this._def;
    r.minSize !== null && n.data.size < r.minSize.value && (h(n, {
      code: d.too_small,
      minimum: r.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.minSize.message
    }), s.dirty()), r.maxSize !== null && n.data.size > r.maxSize.value && (h(n, {
      code: d.too_big,
      maximum: r.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.maxSize.message
    }), s.dirty());
    const i = this._def.valueType;
    function a(c) {
      const l = /* @__PURE__ */ new Set();
      for (const u of c) {
        if (u.status === "aborted")
          return g;
        u.status === "dirty" && s.dirty(), l.add(u.value);
      }
      return { status: s.value, value: l };
    }
    const o = [...n.data.values()].map((c, l) => i._parse(new te(n, c, n.path, l)));
    return n.common.async ? Promise.all(o).then((c) => a(c)) : a(o);
  }
  min(e, s) {
    return new we({
      ...this._def,
      minSize: { value: e, message: p.toString(s) }
    });
  }
  max(e, s) {
    return new we({
      ...this._def,
      maxSize: { value: e, message: p.toString(s) }
    });
  }
  size(e, s) {
    return this.min(e, s).max(e, s);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
we.create = (t, e) => new we({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: v.ZodSet,
  ...k(e)
});
class Jt extends w {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: s } = this._processInputParams(e);
    return this._def.getter()._parse({ data: s.data, path: s.path, parent: s });
  }
}
Jt.create = (t, e) => new Jt({
  getter: t,
  typeName: v.ZodLazy,
  ...k(e)
});
class ft extends w {
  _parse(e) {
    if (e.data !== this._def.value) {
      const s = this._getOrReturnCtx(e);
      return h(s, {
        received: s.data,
        code: d.invalid_literal,
        expected: this._def.value
      }), g;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
ft.create = (t, e) => new ft({
  value: t,
  typeName: v.ZodLiteral,
  ...k(e)
});
function Fs(t, e) {
  return new me({
    values: t,
    typeName: v.ZodEnum,
    ...k(e)
  });
}
class me extends w {
  _parse(e) {
    if (typeof e.data != "string") {
      const s = this._getOrReturnCtx(e), n = this._def.values;
      return h(s, {
        expected: S.joinValues(n),
        received: s.parsedType,
        code: d.invalid_type
      }), g;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const s = this._getOrReturnCtx(e), n = this._def.values;
      return h(s, {
        received: s.data,
        code: d.invalid_enum_value,
        options: n
      }), g;
    }
    return F(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const s of this._def.values)
      e[s] = s;
    return e;
  }
  get Values() {
    const e = {};
    for (const s of this._def.values)
      e[s] = s;
    return e;
  }
  get Enum() {
    const e = {};
    for (const s of this._def.values)
      e[s] = s;
    return e;
  }
  extract(e, s = this._def) {
    return me.create(e, {
      ...this._def,
      ...s
    });
  }
  exclude(e, s = this._def) {
    return me.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...s
    });
  }
}
me.create = Fs;
class Xt extends w {
  _parse(e) {
    const s = S.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== m.string && n.parsedType !== m.number) {
      const r = S.objectValues(s);
      return h(n, {
        expected: S.joinValues(r),
        received: n.parsedType,
        code: d.invalid_type
      }), g;
    }
    if (this._cache || (this._cache = new Set(S.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const r = S.objectValues(s);
      return h(n, {
        received: n.data,
        code: d.invalid_enum_value,
        options: r
      }), g;
    }
    return F(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Xt.create = (t, e) => new Xt({
  values: t,
  typeName: v.ZodNativeEnum,
  ...k(e)
});
class je extends w {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: s } = this._processInputParams(e);
    if (s.parsedType !== m.promise && s.common.async === !1)
      return h(s, {
        code: d.invalid_type,
        expected: m.promise,
        received: s.parsedType
      }), g;
    const n = s.parsedType === m.promise ? s.data : Promise.resolve(s.data);
    return F(n.then((r) => this._def.type.parseAsync(r, {
      path: s.path,
      errorMap: s.common.contextualErrorMap
    })));
  }
}
je.create = (t, e) => new je({
  type: t,
  typeName: v.ZodPromise,
  ...k(e)
});
class pe extends w {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === v.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: s, ctx: n } = this._processInputParams(e), r = this._def.effect || null, i = {
      addIssue: (a) => {
        h(n, a), a.fatal ? s.abort() : s.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
      const a = r.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(a).then(async (o) => {
          if (s.value === "aborted")
            return g;
          const c = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return c.status === "aborted" ? g : c.status === "dirty" || s.value === "dirty" ? _e(c.value) : c;
        });
      {
        if (s.value === "aborted")
          return g;
        const o = this._def.schema._parseSync({
          data: a,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? g : o.status === "dirty" || s.value === "dirty" ? _e(o.value) : o;
      }
    }
    if (r.type === "refinement") {
      const a = (o) => {
        const c = r.refinement(o, i);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? g : (o.status === "dirty" && s.dirty(), a(o.value), { status: s.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? g : (o.status === "dirty" && s.dirty(), a(o.value).then(() => ({ status: s.value, value: o.value }))));
    }
    if (r.type === "transform")
      if (n.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!he(a))
          return g;
        const o = r.transform(a.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: s.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((a) => he(a) ? Promise.resolve(r.transform(a.value, i)).then((o) => ({
          status: s.value,
          value: o
        })) : g);
    S.assertNever(r);
  }
}
pe.create = (t, e, s) => new pe({
  schema: t,
  typeName: v.ZodEffects,
  effect: e,
  ...k(s)
});
pe.createWithPreprocess = (t, e, s) => new pe({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: v.ZodEffects,
  ...k(s)
});
class J extends w {
  _parse(e) {
    return this._getType(e) === m.undefined ? F(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
J.create = (t, e) => new J({
  innerType: t,
  typeName: v.ZodOptional,
  ...k(e)
});
class ye extends w {
  _parse(e) {
    return this._getType(e) === m.null ? F(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ye.create = (t, e) => new ye({
  innerType: t,
  typeName: v.ZodNullable,
  ...k(e)
});
class ht extends w {
  _parse(e) {
    const { ctx: s } = this._processInputParams(e);
    let n = s.data;
    return s.parsedType === m.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: s.path,
      parent: s
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ht.create = (t, e) => new ht({
  innerType: t,
  typeName: v.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...k(e)
});
class mt extends w {
  _parse(e) {
    const { ctx: s } = this._processInputParams(e), n = {
      ...s,
      common: {
        ...s.common,
        issues: []
      }
    }, r = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return De(r) ? r.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new K(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: r.status === "valid" ? r.value : this._def.catchValue({
        get error() {
          return new K(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
mt.create = (t, e) => new mt({
  innerType: t,
  typeName: v.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...k(e)
});
class Qt extends w {
  _parse(e) {
    if (this._getType(e) !== m.nan) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: d.invalid_type,
        expected: m.nan,
        received: n.parsedType
      }), g;
    }
    return { status: "valid", value: e.data };
  }
}
Qt.create = (t) => new Qt({
  typeName: v.ZodNaN,
  ...k(t)
});
class Pi extends w {
  _parse(e) {
    const { ctx: s } = this._processInputParams(e), n = s.data;
    return this._def.type._parse({
      data: n,
      path: s.path,
      parent: s
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class St extends w {
  _parse(e) {
    const { status: s, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? g : i.status === "dirty" ? (s.dirty(), _e(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const r = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return r.status === "aborted" ? g : r.status === "dirty" ? (s.dirty(), {
        status: "dirty",
        value: r.value
      }) : this._def.out._parseSync({
        data: r.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, s) {
    return new St({
      in: e,
      out: s,
      typeName: v.ZodPipeline
    });
  }
}
class pt extends w {
  _parse(e) {
    const s = this._def.innerType._parse(e), n = (r) => (he(r) && (r.value = Object.freeze(r.value)), r);
    return De(s) ? s.then((r) => n(r)) : n(s);
  }
  unwrap() {
    return this._def.innerType;
  }
}
pt.create = (t, e) => new pt({
  innerType: t,
  typeName: v.ZodReadonly,
  ...k(e)
});
I.lazycreate;
var v;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(v || (v = {}));
const Ye = ut.create;
se.create;
const $i = U.create, ji = I.create;
I.strictCreate;
const Fi = Pe.create;
$e.create;
ce.create;
const He = ft.create, Li = me.create;
je.create;
J.create;
ye.create;
const Yi = Fi([
  He("mobile"),
  He("tablet"),
  He("desktop"),
  $i(Li(["mobile", "tablet", "desktop"]))
]).optional();
function zi(t) {
  return Us(() => {
    const s = {
      "data-screen-mobile": "hidden",
      "data-screen-tablet": "hidden",
      "data-screen-desktop": "hidden"
    };
    return t ? (Array.isArray(t) ? t : [t]).forEach((r) => {
      r === "mobile" ? s["data-screen-mobile"] = "visible" : r === "tablet" ? s["data-screen-tablet"] = "visible" : r === "desktop" && (s["data-screen-desktop"] = "visible");
    }) : (s["data-screen-mobile"] = "visible", s["data-screen-tablet"] = "visible", s["data-screen-desktop"] = "visible"), s;
  }, [t]);
}
const Bi = ji({
  mobile: Ye().nullable().optional(),
  tablet: Ye().nullable().optional(),
  desktop: Ye().nullable().optional()
}).optional(), Ui = Bi.transform((t) => {
  if (!t || Object.keys(t).length === 0)
    return ["mobile", "tablet", "desktop"];
  const { mobile: e = !1, tablet: s = e, desktop: n = !1 } = t;
  return [
    e && "mobile",
    s && "tablet",
    n && "desktop"
  ].filter(Boolean);
}).optional();
function Hi(t) {
  const e = Ui.parse(t);
  return zi(e);
}
const Je = (t) => {
  const [e, s] = Fe(!1);
  return oe(() => {
    const n = window.matchMedia(t);
    s(n.matches);
    const r = (i) => s(i.matches);
    return n.addEventListener("change", r), () => n.removeEventListener("change", r);
  }, [t]), e;
}, Ji = () => {
  const t = {
    mobile: Je("(max-width: 767px)"),
    tablet: Je("(min-width: 768px) and (max-width: 1024px)"),
    desktop: Je("(min-width: 1025px)"),
    active: ""
  };
  switch (!0) {
    case t.mobile:
      t.active = "mobile";
      break;
    case t.tablet:
      t.active = "tablet";
      break;
    case t.desktop:
      t.active = "desktop";
      break;
  }
  return t;
}, Wi = 500;
function Xi(t, e) {
  const [s, n] = Fe(t);
  return oe(() => {
    const r = setTimeout(
      () => n(t),
      e || Wi
    );
    return () => {
      clearTimeout(r);
    };
  }, [t, e]), s;
}
const Qi = (t) => {
  oe(() => {
    const e = (s) => {
      s.key === "Escape" && t();
    };
    return document.addEventListener("keydown", e), () => {
      document.removeEventListener("keydown", e);
    };
  }, [t]);
};
export {
  Bi as breakpointVisibilitySchema,
  Yi as breakpointsSchema,
  Gi as useBoop,
  Ji as useBreakpoint,
  zi as useBreakpointDataAttributes,
  Hi as useBreakpointVisibility,
  Xi as useDebounce,
  Qi as useEscKey,
  Je as useMediaQuery,
  ui as usePrefersReducedMotion
};
